<template>
    <form v-if="view === 'compose'">
        <hr style="margin-bottom: 20px;">
        <p class="description">
            Assign a Regular Key to this account. The selected account can then sign transactions on its behalf, in addition to (or instead of) the master key.
        </p>

        <label style="font-size: 1.2rem;">Regular Key</label>
        <div class="account-picker" @click="regularKeyPicker()" style="margin-top: 10px;">
            <div class="account-container">
                <h3>{{ regularKeyName || 'Account' }}</h3>
                <code>{{ RegularKey ? compressString(RegularKey, 6) : 'Select by clicking...' }}</code>
            </div>
            <label class="label">
                <img src="../../assets/svg/chevron-left.svg" style="transform: rotate(180deg);" class="invert-color">
            </label>
        </div>

        <SpinnerButton class="btn btn-success push-top" @click="prepareTx()">{{ $t('buttons.submit') }}</SpinnerButton>
    </form>

    <div v-else-if="view === 'view'" style="padding: 20px 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;">
        <h4>Regular Key</h4>
        <code>{{ compressString(transaction.txjson.RegularKey, 12) }}</code>
    </div>

    <div v-else-if="view === 'listItem'" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 15px; padding-top: 10px;">
        <span>Regular Key</span>
        <code>{{ compressString(transaction.txjson.RegularKey, 5) }}</code>
    </div>
</template>

<script>
// https://xrpl.org/setregularkey.html

import xapp from '../../plugins/xapp'
import mixin from '../../mixins/multiSign'

import { compressString } from '../../plugins/number-format'

export default {
    props: {
        view: {
            validator(value) {
                return ['compose', 'view', 'listItem'].includes(value)
            }
        },
        transaction: Object
    },
    mixins: [mixin],
    data() {
        return {
            TransactionType: 'SetRegularKey',
            RegularKey: null,
            regularKeyName: null
        }
    },
    computed: {
        txjson() {
            if(!this.NextTicketSequence || !this.RegularKey) return null

            return {
                TransactionType: this.TransactionType,
                RegularKey: this.RegularKey,
                TicketSequence: this.NextTicketSequence,
                Sequence: 0
            }
        }
    },
    methods: {
        compressString,
        prepareTx() {
            if(!this.RegularKey) return alert('Select an account to use as the Regular Key')
            return this.sendTx(this.txjson)
        },
        async regularKeyPicker() {
            try {
                const result = await xapp.destinationSelect()
                if(!result.destination || result.destination === null) return null

                this.regularKeyName = result.destination.name
                this.RegularKey = result.destination.address
            } catch (e) {
                console.log(e)
                this.$emitter.emit('modal', {
                    type: 'error',
                    title: this.$t('xapp.error.modal_title'),
                    text: 'Error with the Account Selector',
                    buttonText: this.$t('xapp.button.close')
                })
            }
        }
    }
}
</script>

<style scoped>
.description {
    color: var(--grey);
    font-size: 0.9rem;
    margin-bottom: 20px;
}
</style>
